module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/main-visual_beach-photo-c64454f02819a54fa1449651064eac7f.jpg";